'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PreviewBox = function (_React$Component) {
	_inherits(PreviewBox, _React$Component);

	function PreviewBox() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, PreviewBox);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PreviewBox.__proto__ || Object.getPrototypeOf(PreviewBox)).call.apply(_ref, [this].concat(args))), _this), _this.updateSize = function (event) {
			event.preventDefault();
			_this.props.changeVal(event, 'size');
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(PreviewBox, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    color = _props.color,
			    unit = _props.unit,
			    code = _props.code,
			    internal_id = _props.internal_id,
			    codeType = _props.codeType;


			var icon = _react2.default.createElement(_SvgIcon2.default, { icon: '#' + internal_id, isCustom: true });
			var styleOptions = {
				fontSize: 180
			};

			if (codeType !== 'editor' && codeType !== 'attribution') {
				styleOptions['color'] = color;
			}

			if (code) {
				icon = _react2.default.createElement('div', { className: 'ip-icon-custom', dangerouslySetInnerHTML: { __html: code } });
				styleOptions = { fontSize: 180 };
			}

			return _react2.default.createElement(
				'div',
				{ className: 'ip-cmPreview' },
				_react2.default.createElement(
					'div',
					{ className: 'ip-cmPreview-box', style: styleOptions },
					icon
				)
			);
		}
	}]);

	return PreviewBox;
}(_react2.default.Component);

exports.default = PreviewBox;


//////////////////
// WEBPACK FOOTER
// ./src/components/PreviewBox.js
// module id = 265
// module chunks = 0 1